import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OfferCustomerResponse } from '../../../models/offerCustomerGenerated.model';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { Link } from '../../../models/link';

@Component({
  selector: 'app-links-modal',
  templateUrl: './links-modal.component.html',
  styleUrl: './links-modal.component.css'
})
export class LinksModalComponent {
  links: Link[];
  constructor(
    public dialogRef: MatDialogRef<LinksModalComponent>,
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: { links: Link[] }
  ) {
    this.links = data.links;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close();
  }

  onCopyLink(link: string): void{
    navigator.clipboard.writeText(link)
    .then(
      () => {
        var message = this.translationService.translate("Link copied");
        this.snackBar.showCustom(message, 'content_copy');
      },
      (err) => {
        var message = this.translationService.translate("Error on copy link");
        this.snackBar.showError(message)
      }
    )
  }
}
